(function () {
  if (window.LaifenCollectionFeatureSlider) {
    window.LaifenCollectionFeatureSlider.initAll();
    return;
  }

  var selector = '[data-cfc-carousel]';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clampIndex(value, slides) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed)) return 0;
    return Math.max(0, Math.min(slides.length - 1, parsed));
  }

  function wrapIndex(value, length) {
    if (length < 1) return 0;
    return ((value % length) + length) % length;
  }

  function init(root) {
    if (!root || root.getAttribute('data-cfc-ready') === 'true') return;

    var viewport = root.querySelector('[data-cfc-viewport]');
    var track = root.querySelector('[data-cfc-track]');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-cfc-slide]'));
    if (!slides.length) return;

    var dotsWrap = root.querySelector('[data-cfc-dots]');
    var dots = [];
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var current = clampIndex(mobileQuery && mobileQuery.matches ? root.dataset.initialMobile : root.dataset.initialDesktop, slides);
    var timer = null;
    var dragging = false;
    var startX = 0;
    var baseX = 0;
    var moved = 0;

    root.setAttribute('data-cfc-ready', 'true');

    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'collection-feature-slider__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { goTo(i); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function centerOffsetFor(index) {
      var slide = slides[index];
      return (viewport.clientWidth - slide.offsetWidth) / 2 - slide.offsetLeft;
    }

    function setTransform(value, animate) {
      track.style.transition = animate ? 'transform .5s cubic-bezier(.22,.61,.36,1)' : 'none';
      track.style.transform = 'translateX(' + value + 'px)';
    }

    function updateState() {
      slides.forEach(function (slide, index) {
        var active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function goTo(index, animate) {
      current = wrapIndex(index, slides.length);
      setTransform(centerOffsetFor(current), animate !== false);
      updateState();
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || slides.length < 2) return;
      timer = window.setInterval(function () {
        goTo(current + 1);
      }, Math.max(interval, 1000));
    }

    function restart() {
      stop();
      start();
    }

    function pointerX(event) {
      return event.touches ? event.touches[0].clientX : event.clientX;
    }

    function onPointerDown(event) {
      dragging = true;
      moved = 0;
      startX = pointerX(event);
      baseX = centerOffsetFor(current);
      track.classList.add('is-dragging');
      setTransform(baseX, false);
      stop();
    }

    function onPointerMove(event) {
      if (!dragging) return;
      moved = pointerX(event) - startX;
      setTransform(baseX + moved, false);
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');

      var threshold = Math.max(48, viewport.clientWidth * 0.08);
      if (moved < -threshold) {
        goTo(current + 1);
      } else if (moved > threshold) {
        goTo(current - 1);
      } else {
        goTo(current);
      }
      start();
    }

    viewport.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);
    viewport.addEventListener('touchstart', onPointerDown, { passive: true });
    viewport.addEventListener('touchmove', onPointerMove, { passive: true });
    viewport.addEventListener('touchend', onPointerUp);

    viewport.addEventListener('click', function (event) {
      if (Math.abs(moved) > 5) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        goTo(current, false);
      }, 120);
    });

    root.cfcGoTo = function (index) {
      goTo(index);
      restart();
    };

    goTo(current, false);
    start();
  }

  function initAll(scope) {
    var context = scope || document;
    Array.prototype.slice.call(context.querySelectorAll(selector)).forEach(init);
  }

  function ready() {
    initAll(document);
  }

  window.LaifenCollectionFeatureSlider = {
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target && event.target.closest ? event.target.closest('[data-cfc-slide]') : null;
    if (!slide) return;

    var root = slide.closest(selector);
    if (!root || !root.cfcGoTo) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cfc-slide]'));
    root.cfcGoTo(slides.indexOf(slide));
  });
})();
